import React from "react";
import PropTypes from "prop-types";

const newLineRegex = /(\r\n|\r|\n)/g;

export const NlToBr = ({ children }) => {
  if (!children) {
    return null;
  }
  if (typeof children !== "string") {
    return children;
  }
  return children.split(newLineRegex).map((line, index) => {
    if (line.match(newLineRegex)) {
      return <br key={index} />;
    }
    return line;
  });
};

NlToBr.propTypes = {
  children: PropTypes.node,
};
